const toBase64 = (files: File): Promise<string | ArrayBuffer> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(files);
    reader.onload = (): void => resolve(reader.result);
    reader.onerror = (error): void => reject(error);
  });

export default toBase64;
